import {PrizePool} from "@devour/client";
import {useEffect} from "react";
import {BrandChallengePrizeWonModal} from "./BrandChallengePrizeWonModal";
import {useGetChallengePrizesWon} from "@/hooks/useGetChallengePrizesWon";
import useRefreshRewardData from "@/hooks/useRefreshRewardData";

export const BrandChallengesPrizeNotifier = () => {
    const {data: prizes = [], refetch} = useGetChallengePrizesWon(true);
    const {refetch: refreshOWRewardData} = useRefreshRewardData();

    useEffect(() => {
        if (prizes.length > 0) {
            const prizeTypes = new Set(prizes.map((prize: PrizePool) => prize.type));
            prizeTypes.forEach(type => {
                void refreshOWRewardData(type);
            });
        }
    }, [prizes]);

    const handleAccepted = async () => {
        await refetch();
    };

    return (
        <BrandChallengePrizeWonModal
            isOpen={!!prizes[0] && !prizes[0].notifiedWinner}
            prize={prizes[0]}
            onAccepted={handleAccepted}
        />
    );
};
